const STORAGE_KEY = 'hids.frostedOpacity';
const BG_STORAGE_KEY = 'hids.backgroundImage';
const MENU_COLOR_KEY = 'hids.menuColor';
const MENU_OPACITY_KEY = 'hids.menuOpacity';
const DEFAULT_OPACITY = 0.7;
const DEFAULT_MENU_COLOR = '#c3b0a9';
const DEFAULT_MENU_OPACITY = 1.0;

export const settingsUtils = {
  setFrostedOpacity(opacity: number): void {
    const clamped = Math.max(0, Math.min(1, opacity));
    const el = document.querySelector('.hids-app') as HTMLElement | null;
    if (!el) return;

    const bgValue = `rgba(255, 255, 255, ${clamped})`;
    el.style.setProperty('--hids-frosted-bg', bgValue);
    el.style.setProperty('--cdphe-drawer-bg', bgValue);
  },

  getFrostedOpacity(): number | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw === null) return null;
      const val = parseFloat(raw);
      return isNaN(val) ? null : val;
    } catch {
      return null;
    }
  },

  saveFrostedOpacity(opacity: number): void {
    const clamped = Math.max(0, Math.min(1, opacity));
    localStorage.setItem(STORAGE_KEY, clamped.toString());
  },

  initFrostedOpacity(): void {
    const opacity = settingsUtils.getFrostedOpacity();
    if (opacity !== null) {
      settingsUtils.setFrostedOpacity(opacity);
    }
  },

  setBackgroundImage(dataUrl: string): void {
    const el = document.querySelector('.hids-app') as HTMLElement | null;
    if (!el) return;
    el.style.backgroundImage = `url(${dataUrl})`;
  },

  getBackgroundImage(): string | null {
    try {
      return localStorage.getItem(BG_STORAGE_KEY);
    } catch {
      return null;
    }
  },

  saveBackgroundImage(dataUrl: string): void {
    localStorage.setItem(BG_STORAGE_KEY, dataUrl);
  },

  removeBackgroundImage(): void {
    localStorage.removeItem(BG_STORAGE_KEY);
    const el = document.querySelector('.hids-app') as HTMLElement | null;
    if (!el) return;
    el.style.backgroundImage = '';
  },

  initBackgroundImage(): void {
    const dataUrl = settingsUtils.getBackgroundImage();
    if (dataUrl) {
      settingsUtils.setBackgroundImage(dataUrl);
    }
  },

  _hexToRgba(hex: string, opacity: number): string {
    const h = hex.replace('#', '');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  },

  setMenuColor(hexColor: string, opacity: number): void {
    const el = document.querySelector('.hids-app') as HTMLElement | null;
    if (!el) return;
    const clamped = Math.max(0, Math.min(1, opacity));
    el.style.setProperty('--cdphe-appbar-bg', settingsUtils._hexToRgba(hexColor, clamped));
  },

  getMenuColor(): string | null {
    try {
      return localStorage.getItem(MENU_COLOR_KEY);
    } catch {
      return null;
    }
  },

  saveMenuColor(hexColor: string): void {
    localStorage.setItem(MENU_COLOR_KEY, hexColor);
  },

  getMenuOpacity(): number | null {
    try {
      const raw = localStorage.getItem(MENU_OPACITY_KEY);
      if (raw === null) return null;
      const val = parseFloat(raw);
      return isNaN(val) ? null : val;
    } catch {
      return null;
    }
  },

  saveMenuOpacity(opacity: number): void {
    const clamped = Math.max(0, Math.min(1, opacity));
    localStorage.setItem(MENU_OPACITY_KEY, clamped.toString());
  },

  removeMenuColor(): void {
    localStorage.removeItem(MENU_COLOR_KEY);
    localStorage.removeItem(MENU_OPACITY_KEY);
    const el = document.querySelector('.hids-app') as HTMLElement | null;
    if (!el) return;
    el.style.removeProperty('--cdphe-appbar-bg');
  },

  initMenuColor(): void {
    const color = settingsUtils.getMenuColor();
    const opacity = settingsUtils.getMenuOpacity();
    if (color) {
      settingsUtils.setMenuColor(color, opacity ?? DEFAULT_MENU_OPACITY);
    }
  }
};

if (typeof window !== 'undefined') {
  (window as any).settingsUtils = settingsUtils;

  settingsUtils.initFrostedOpacity();
  settingsUtils.initBackgroundImage();
  settingsUtils.initMenuColor();
}
